import clsx from "clsx";

const LiveDot = ({ onBrand = false }: { onBrand?: boolean }) => (
  <span
    aria-hidden="true"
    className={clsx(
      "relative flex size-3.5 shrink-0 items-center justify-center rounded-full",
      onBrand ? "bg-white/20" : "bg-tm-c-green/20",
    )}
  >
    <span
      className={clsx(
        "absolute inset-0 rounded-full animate-ping [animation-duration:1.8s] motion-reduce:hidden",
        onBrand ? "bg-white/60" : "bg-tm-c-green/60",
      )}
    />
    <span
      className={clsx(
        "relative size-2 rounded-full",
        onBrand ? "bg-white" : "bg-tm-c-green",
      )}
    />
  </span>
);

export default LiveDot;
